import { AgencySearchQuery } from '../../../generated/graphql';
import { SearchTypeView } from '../../../tracking/search-results/enums';
import type { SearchResultsBaseProperties } from '../../../tracking/search-results';
import { SearchResultsState } from './get-search-from-query';
import {
  formatSuburbsForTracking,
  mapAgentFilterToEnum,
} from './format-suburbs-for-tracking';
import {
  DEFAULT_SORT_LABEL,
  SORT_OPTIONS_AGENCIES_2026,
  SORT_OPTIONS_AGENTS_2026,
} from '../components/search-filter-bar/enums';

export const sortLabelOf = (state: SearchResultsState): string => {
  const sortOptions = state.isAgency
    ? SORT_OPTIONS_AGENCIES_2026
    : SORT_OPTIONS_AGENTS_2026;

  return (
    sortOptions.find((option) => option.value === state.sortBy)?.label ??
    DEFAULT_SORT_LABEL
  );
};

export const resultsCountOf = (
  data: AgencySearchQuery | undefined,
  state: SearchResultsState,
): number | undefined => {
  const total = state.isAgency
    ? data?.agencySearchBySuburbs?.total
    : data?.contactSearchBySuburbs?.total;

  return total ?? undefined;
};

const buildSearchResultsBaseProperties = (
  data: AgencySearchQuery | undefined,
  state: SearchResultsState | null,
): SearchResultsBaseProperties => {
  if (!state) {
    return {};
  }

  const searchFilterSuburb = formatSuburbsForTracking(
    data?.locationProfiles ?? undefined,
  );
  const resultsCount = resultsCountOf(data, state);

  return {
    searchTypeView: SearchTypeView.ListView,
    searchSortBy: sortLabelOf(state),
    ...(searchFilterSuburb.length > 0 && { searchFilterSuburb }),
    ...(state.isAgency
      ? {}
      : { searchFilterAgentType: mapAgentFilterToEnum(state.agentFilter) }),
    ...(typeof resultsCount === 'number' && {
      searchResultsReturnedCount: resultsCount,
    }),
    searchResultsPageDepth: state.page,
  };
};

export default buildSearchResultsBaseProperties;
